export enum SymptomsControlCodes {
    ARTICLES = 'articles',
    SIDE_EFFECTS = 'sideEffect',
    TAGS = 'tags'
}
